import VmpPrivacyCompliance from './src/main.vue';

VmpPrivacyCompliance.install = function (Vue) {
  Vue.component(VmpPrivacyCompliance.name, VmpPrivacyCompliance);
};

export default VmpPrivacyCompliance;
